import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import "@fontsource/roboto";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { 
    id: "G-7H5X51WQPC",
    params: {
      anonymize_ip: true,
      send_page_view: true,
    }
  }
})

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
